export function thirdParty(_name: string, _purpose: string, _policyUrl: string): void {
	return;
}
